import vueInject from 'vue-inject'

class VueServiceInjector {

  injectService(name, serviceInstance) {
    vueInject.service(name, () => serviceInstance);
  };
}

export let injector = new VueServiceInjector();
window.com.jacada.common.injector.serviceInjectors.push(injector);





// WEBPACK FOOTER //
// ./src/services/vueServiceInjector.js